import styled from "styled-components";

import { FONTS, SPACING } from "../../../../utils/constants";

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  padding: ${SPACING.md}px;
  border-radius: 12px;
  background: var(--color-info-background);
  border: 1px solid var(--color-info-border);
  color: var(--color-text-default);
  font-family: ${FONTS.serif};
`;

export const BannerTitle = styled.span`
  font-weight: 700;
  font-size: var(--text-md);
`;

export const BannerSubtitle = styled.span`
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;
